import {Component} from '@angular/core';
import {LoadingIndicatorService} from '@services/loading-indicator/loading-indicator.service';

@Component({
    selector: 'scitis-loading-indicator',
    templateUrl: './loading-indicator.component.html',
    styleUrls: ['./loading-indicator.component.scss'],
    standalone: false
})
export class LoadingIndicatorComponent  {

  constructor(private loadingIndicatorService: LoadingIndicatorService) {
  }

  public showLoadingIndicator(): boolean {
    return this.loadingIndicatorService.getVisibility();
  }

  public getLoadingIndicatorMessage(): string {
    return this.loadingIndicatorService.getLoadingMessage();
  }


}
